/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useSyncExternalStore as e}from"../use-sync-external-store-shim/index.js";function s(s){return e(s.subscribe,s.getSnapshot,s.getSnapshot)}export{s as useStore};
//# sourceMappingURL=use-store.js.map
